<template>
    <div class="user-management">
      <div class="header">
        <el-input placeholder="搜索用户" v-model="searchKeyword" class="input-with-select" size="mini">
          <el-button slot="append" icon="el-icon-search" @click="getUserList"></el-button>
        </el-input>
      </div>
  
      <div class="content" v-loading="loading">
        <el-table :data="userList" stripe style="width: 100%">
          <!-- <el-table-column prop="_id" label="ID" ></el-table-column> -->
          <el-table-column prop="avatar" label="头像" width="80">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.avatar"
                :preview-src-list="scope.row.avatar ? [scope.row.avatar] : []"
                style="width: 40px; height: 40px;"
              >
                <div slot="error" class="image-slot" style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; background-color: #f5f7fa; border-radius: 50%;">
                  <i class="el-icon-user" style="font-size: 20px; color: #c0c4cc;"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="nickname" label="昵称" ></el-table-column>
          <el-table-column prop="email" label="邮箱" ></el-table-column>
          <el-table-column prop="points" label="积分" ></el-table-column>
          <el-table-column prop="isDoctorCertified" label="医生认证" width="100">
            <template slot-scope="scope">
              <el-tag
                :type="getCertificationTagType(scope.row.isDoctorCertified)"
              >
                {{ getCertificationText(scope.row.isDoctorCertified) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="注册时间" width="160"></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="editUser(scope.row._id)">编辑</el-button>
              <!-- <el-button type="text" size="mini" @click="deleteUser(scope.row._id)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
  
        <div class="pagination">
          <el-pagination
            @current-change="handlePageChange"
            :current-page="pagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { getUserList, deleteUser } from "@/api/user";
  
  export default {
    data() {
      return {
        loading: true,
        userList: [],
        searchKeyword: '',
        pagination: {
          page: 1,
          pageSize: 10,
          total: 0,
        },
      };
    },
    methods: {
      getCertificationTagType(status) {
        if (status === 2) {
          return 'success'; // 认证成功
        } else if (status === 1) {
          return 'warning'; // 审核中
        } else {
          return 'danger'; // 未认证
        }
      },
      
      getCertificationText(status) {
        if (status === 2) {
          return '认证成功';
        } else if (status === 1) {
          return '审核中';
        } else {
          return '未认证';
        }
      },
      async getUserList() {
        this.loading = true;
        try {
          const param = { 
            page: this.pagination.page,
            pageSize: this.pagination.pageSize,
            keywords: this.searchKeyword 
          }
          const { data } = await getUserList(param);
          this.userList = data.users;
          this.pagination.total = data.total;
        } catch (error) {
          this.$message.error('获取用户列表失败');
        } finally {
          this.loading = false;
        }
      },
      handlePageChange(page) {
        this.pagination.page = page;
        this.getUserList();
      },
      editUser(userId) {
        // 编辑用户逻辑
        this.$router.push({ name: "user-edit", query: { userId } });
      },
      async deleteUser(userId) {
        try {
          await deleteUser(userId);
          this.$message.success('用户已删除');
          this.getUserList();
        } catch (error) {
          this.$message.error('删除用户失败');
        }
      },
    },
    mounted() {
      this.getUserList();
    },
  };
  </script>
  
  <style scoped>
  .content {
    width: 90%;
    margin: 0 auto;
  }
  .user-management .header {
    padding: 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
  .input-with-select {
    width: 200px;
    margin-left: 3%;
  }
  </style>
  